export var Readyness;
(function (Readyness) {
    Readyness["NotReady"] = "NotReady";
    Readyness["Ready"] = "Ready";
    Readyness["Failed"] = "Failed";
})(Readyness || (Readyness = {}));
//# sourceMappingURL=featurehub_repository.js.map